export { Typography500 } from "./Typography500";
